/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import classes from './ShoppingCart.module.scss'
import cx from "classnames";
import { BedSvg, CalendarSvg, ClassSvg, ClockSvg, CountryFlagSvg, DangerCircleSvg, DeleteSvg, DownSvg, DurationSvg, FeetSvg, FlagSvg, FlightSvg, MapSvg, PersonSvg, SmallTrainSvg, StarSvg, UpArrowSvg } from '../../constants/resources'
import moment from 'moment';
import { StyledCheckbox } from '../../atom/Checkbox';
import ReactGA from 'react-ga4';
import showMessage from './Common/notification';
import cartLogo from '../../asset/cart.jpg'
import DeleteModal from '../../atom/DeleteModal';
import { ItineraryFull, UserProfile } from '../../atom/Types';
import Loader from './Common/Loader';
import Helper from '../../Helper';
import { gql } from '@apollo/client';
import { useMutation } from "@apollo/client";
import { v4 as uuidv4 } from 'uuid';
import EmailTemplate from '../../atom/EmailTemplate';
import { checkSpacing, handleConnectionDuration, handleDuration, keyExistInObject, Time } from '../../atom/utilities/function';
import { useSelector } from 'react-redux';
import { RootState } from '../../App';
import { useAuth0, User } from '@auth0/auth0-react';
import { SEND_EMAIL, UPDATE_BOOKING_STATUS_ACCO, UPDATE_BOOKING_STATUS_FLIGHT, UPDATE_BOOKING_STATUS_INS, UPDATE_BOOKING_STATUS_TRAIN } from '../../graphQL/mutations';
import SuccessPage from './successPage';
import { Tooltip } from 'react-tooltip';
import ActualTime from './Common/timezone';
import { getENVData } from '../../constants/constantValue';

const ADD_TRANSACTION_RECORD = gql`mutation MyMutation($input: [AddTransactionRecordInput!]!) {
    addTransactionRecord(input: $input) {
        numUids
        transactionRecord {
            id
            paymentRecords {
                amount
                cardToken
                description
                id
                itinerariyBase {
                    id
                }
            }
        }
    }
}`;

const UPDATE_BOOKING_STATUS = gql`
mutation MyMutation($id: [ID!]!, $bookingStatus: BookingStatus!) {
    updateItineraryActivity(input: {filter: {id: $id}, set: {bookingStatus: $bookingStatus}}) {
        numUids
    }
}`;

interface props {
    ItineraryData: ItineraryFull
}
const ShoppingCart: React.FC<props> = ({ ItineraryData }) => {
    //const [UpdatePaymentRecord] = useMutation(UPDATE_PAYMENT_RECORD);
    const [AddTransactionRecord] = useMutation(ADD_TRANSACTION_RECORD);
    const [Email] = useMutation(SEND_EMAIL, {
        onError: (error) => {

        }
    })

    const { user } = useAuth0()
    const [showDetail, setShowDetail] = useState<string>('');
    const [priceDetail, setPriceDetail] = useState<boolean>(false);
    const [checked, setChecked] = useState<boolean>(false);
    const [modal, setModal] = useState<string>('');
    const [loader, setLoader] = useState(false)
    const [cart, setCart] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [updateBookingStatus] = useMutation(UPDATE_BOOKING_STATUS);
    const [updateIns] = useMutation(UPDATE_BOOKING_STATUS_INS)
    const [updateTrain] = useMutation(UPDATE_BOOKING_STATUS_TRAIN)
    const [updateFlight] = useMutation(UPDATE_BOOKING_STATUS_FLIGHT)
    const [updateAcco] = useMutation(UPDATE_BOOKING_STATUS_ACCO)
    const { Profile } = useSelector((state: RootState) => state?.Question);
    const env = getENVData()
    console.log(ItineraryData, 'ItineraryData');


    useEffect(() => {
        setLoading(true)
        let cartItem = localStorage.getItem(ItineraryData.queryItinerary[0].key)
        if (cartItem !== null)
            setCart(JSON.parse(cartItem))
        else
            setCart([])
        setLoading(false)
    }, [])
    console.log(cart, 'loooper');


    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked);
    };

    const handleCheckout = async () => {
        if (checked === false) {
            showMessage('Terms and Conditions', 'please accept terms and conditions to proceed', 'danger')
        }
        else {
            setLoader(true)
            try {
                var price = cart.reduce((accumulator, itineraryComp) => {
                    const payNow = itineraryComp.payNow;
                    let Price = (payNow !== null && payNow > 0) ? payNow : itineraryComp.publishedPrice;
                    if (itineraryComp?.connectionFlights?.length > 0) {
                        itineraryComp?.connectionFlights.forEach((m: any) => {
                            Price = Price + m.publishedPrice
                        })
                    }
                    return accumulator + Price;
                }, 0);

                const itinerary = ItineraryData.queryItinerary[0];
                const title = `${itinerary.name} from ${Helper.formatDate(Helper.dateOnlyToLocalDatetime(itinerary.startDate))} to ${Helper.formatDate(Helper.dateOnlyToLocalDatetime(itinerary.endDate))}`;
                // const persons = itinerary.persons.map((p: any) => `${p.firstName} ${p.lastName}`).join(", ");
                const person = itinerary.travelAnswer.name;
                const activities = cart.map((item: any) => {
                    switch (item.__typename) {
                        case "ItineraryActivity":
                            //return item.activity?.name?.length > 50 ? item.activity?.name?.substring(0, 47) + "..." : item.activity?.name;
                            const words = item.activity?.name.split(' ');

                            return "Activity: " + (words.length > 7 ? words.slice(0, 7).join(' ') + " ..." : item.activity?.name);

                        case "ItineraryFlight":
                            return "Flight: " + item.flight?.flgithNumber;

                        case "ItineraryAccommodation":
                            const word = item?.accommodation?.name.split(' ');
                            return "Accommodation: " + (word.length > 7 ? word.slice(0, 7).join(' ') + " ..." : item.accommodation?.name);
                        default:
                            return null;
                    }
                }).filter((n: any) => !!n).join(", ");

                // 500 max length
                const note = `${title} for ${person} - ${activities}`;
                const res = await Helper.sendToPaymentPromise("squareCreditPayment", {
                    params: {
                        price: price,
                        note: note.substring(0, 500),
                    },
                    onNotify: (title: string, message: string, type: "success" | "danger" | "info" | "default" | "warning") => {
                        showMessage(title, message, type);
                    }
                });

                if (res) {

                    let input = {
                        transactionId: res.orderId + '_' + uuidv4(),
                        transactionDate: new Date(),
                        amount: (res.amountMoney.amount / 100.0).toFixed(2),
                        cardToken: res.orderId || res.id,
                        type: "Payment",
                        receipt_url: res.receiptUrl,
                        paymentRecords: [] as any
                    }
                    const promises: any = []
                    const apiCalls = [
                        { type: 'insurances', apiFunction: updateIns },
                        { type: 'activity', apiFunction: updateBookingStatus },
                        { type: 'train', apiFunction: updateTrain },
                        { type: 'accommodation', apiFunction: updateAcco },
                        { __typename: 'ItineraryFlight', apiFunction: updateFlight },
                    ];
                    for (var i = 0; i < cart.length; i++) {
                        const crt = cart[i] as any;
                        if (crt?.connectionFlights?.length > 0) {
                            crt.connectionFlights.forEach((fli: any) => {
                                cart.push(fli)
                            })
                        }

                        input.paymentRecords.push({
                            paymentId: res.orderId + '_' + uuidv4(),
                            paymentDate: new Date(),
                            title: res.receiptUrl,
                            amount: crt.payNow !== null && crt.payNow > 0 ? +crt.payNow : +crt.publishedPrice,
                            cardToken: res.orderId || res.id,
                            itinerariyBase: {
                                id: crt.id
                            }
                        });
                    }

                    try {
                        await AddTransactionRecord({ variables: { input: input, upsert: true } }).finally(async () => {
                            for (var i = 0; i < cart.length; i++) {
                                const crt = cart[i] as any;
                                const apiCall = apiCalls.find((call) => call.type === crt.type || call.__typename === crt.__typename);
                                if (apiCall) {
                                    promises.push(new Promise(resolve => {
                                        apiCall.apiFunction({
                                            variables: { id: crt.id, bookingStatus: "InProgress" }
                                        }).then(res => resolve(res))
                                            .catch((err) => {
                                                resolve(err)
                                                console.log(err, 'lamoraa');
                                            }
                                            );
                                    }));
                                }
                            }

                            Promise.all(promises).then(async () => {
                                const email = EmailTemplate(ItineraryData?.queryItinerary[0], keyExistInObject(Profile as UserProfile, '') as UserProfile, user as User, cart, 'cart');
                                if (email) {
                                    Email({
                                        variables: {
                                            to: env.email,
                                            ccEmails: env.subEmail,
                                            subject: `${Object.keys(Profile).length > 0 && keyExistInObject(Profile as UserProfile, 'firstName') ? keyExistInObject(Profile as UserProfile, 'firstName') : ItineraryData?.queryItinerary[0]?.travelAnswer?.name ? ItineraryData?.queryItinerary[0]?.travelAnswer?.name : user?.nickname},  ${ItineraryData?.queryItinerary[0]?.name} , has made payment for the itineray`,
                                            body: email,
                                            submitTime: Date.now()
                                        }
                                    }).then((response) => {
                                        localStorage.removeItem(ItineraryData.queryItinerary[0].key)
                                        showMessage('sucessfull', 'email sent sucessfully', 'success')
                                        window.location.assign(window.location.href.split('/cart')[0])
                                        setLoader(false)
                                    })
                                }
                                else {
                                    localStorage.removeItem(ItineraryData.queryItinerary[0].key)
                                    showMessage('error', 'email not sent', 'danger')
                                    window.location.assign(window.location.href.split('/cart')[0])
                                    setLoader(false)
                                }

                            }).catch((ex: any) => {
                                console.error(ex.message)
                                showMessage('error', 'network error', 'danger')

                            })

                        })
                    }
                    catch (ex: any) {
                        console.error(ex.message)
                        showMessage('error', 'network error', 'danger')
                    }
                    Helper.sendToViator({ route: "" });
                }
                else {
                    const email = EmailTemplate(ItineraryData.queryItinerary[0], keyExistInObject(Profile as UserProfile, '') as UserProfile, user as User, [], 'failed');
                    if (email) {
                        Email({
                            variables: {
                                to: env.email,
                                ccEmails: env.subEmail,
                                subject: `Payment Failed`,
                                body: email,
                                submitTime: 1685950252
                            }
                        }).then((response) => {
                            setLoader(false)

                        })
                    }
                }
            }
            catch (ex: any) {
                setLoader(false)
            }

        }
    }

    const Maps = (node: any, place: any) => {
        ReactGA.event({
            category: 'Map',
            action: `Clicked Map ${place}`,

        });
        window.open("https://www.google.com/maps/search/" + node);
    }


    const handleDelete = (id: string) => {

        let copyCart = [...cart]
        let index = copyCart.findIndex((n) => { return n.id === id })
        if (index > -1)
            copyCart.splice(index, 1)
        localStorage.setItem(ItineraryData.queryItinerary[0].key, JSON.stringify(copyCart))
        setCart(copyCart)
        setModal('')
    }

    const handlePrice = (type: string) => {
        let price = 0;
        cart.forEach((element: any) => {
            const { publishedPrice, payNow, __typename, connectionFlights } = element;
            switch (type) {
                case 'total':
                    if (element?.connectionFlights?.length > 0) {
                        element.connectionFlights.forEach((n: any) => {
                            price += n.publishedPrice
                        })
                    }
                    price += publishedPrice;
                    break;
                case 'payLater':
                    if (payNow !== null && payNow > 0) {
                        price += (publishedPrice - payNow);
                    }
                    break;
                default:
                    if (payNow !== null && payNow > 0) {
                        price += payNow
                    }
                    else {
                        if (__typename === "ItineraryFlight" && connectionFlights.length > 0)
                            connectionFlights.forEach((n: any) =>
                                price += n.publishedPrice
                            )
                        price += publishedPrice
                    }
                    break;
            }
        });
        return `$ ${price.toFixed(2)}`;
    }
    const handleDetails = (id: string) => {
        if (showDetail === id)
            setShowDetail('')
        else
            setShowDetail(id)
    }
    const handleFlightPrice = (fli: any) => {
        let price: number = 0
        if (fli.connectionFlights.length > 0) {
            fli.connectionFlights.forEach((n: any) => {
                price += n.publishedPrice
            })
        }
        price += fli.publishedPrice
        return price
    }
    console.log(cart, 'carttttt');


    return (
        <div className={classes.container}>
            {cart.length > 0 && !loading ?
                <div className={classes.shoppingBox}>
                    <div className={classes.box1}>
                        <div className={classes.cart}><p className={classes.poppins}>Cart</p> <span className={classes.hanken}>{cart.length} items</span></div>
                        {cart.map((items: any, key: any) => {
                            return items.type === 'activity' ? <div className={classes.details} key={key}>
                                <div className={classes.head}>
                                    <p className={classes.poppins} style={{ textAlign: 'left', maxWidth: '300px' }}>{items.activity.name}</p>
                                    <div className={classes.tittle}>
                                        <div style={{ cursor: 'pointer' }} onClick={() => setModal(items.id)}>
                                            <DeleteSvg />
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.priceBox}>
                                    <div className={classes.headModal}>
                                        <p className={classes.hanken1} style={{ fontSize: '12px', color: '#545D68' }}>Full Tour Price</p>
                                        <p className={items.payNow !== null && items.payNow > 0 ? classes.span1 : classes.poppins1}>{items.payNow !== null && items.payNow > 0 && <span data-tooltip-id="my-tooltip" data-tooltip-content="You’ll have to pay the rest of a Full Tour Price at a location!"> <DangerCircleSvg /></span>}${items.publishedPrice}</p>
                                        <Tooltip id="my-tooltip"
                                            className={classes.tooltip}
                                        />
                                    </div>
                                    {items.payNow !== null && items.payNow > 0 &&
                                        <>
                                            <hr style={{ width: '100%' }} />
                                            <div className={classes.headModal}>
                                                <p className={classes.hanken1} style={{ fontSize: '12px', color: '#545D68' }}>Pay Now</p>
                                                <p className={classes.poppins} style={{ fontSize: '16px', color: '#0279CF' }}>${items.payNow}</p>
                                            </div>
                                        </>}
                                </div>
                                <hr style={{ width: '100%' }} />
                                <div className={classes.details} style={{ padding: '0px' }}>
                                    <p hidden={window.innerWidth < 768} className={classes.poppins} style={{ fontSize: '14px' }}>Details</p>
                                    <p hidden={window.innerWidth > 768} style={{ alignItems: 'center' }} onClick={() => handleDetails(items.id)} className={classes.hanken2}>{showDetail === items.id ? 'Hide Details' : 'Show Details'} <span>{showDetail === items.id ? <DownSvg rotate={'rotate(180deg)'} /> : <DownSvg rotate={'rotate(0deg)'} />}</span></p>
                                    {(showDetail === items.id || window.innerWidth > 768) && <div className={classes.desc}>
                                        <div className={classes.grid1}>
                                            <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                <CalendarSvg width={"16"} height={"16px"} color={"#273443"} />
                                                <p>Date:</p>
                                                {/* <p>{moment(items?.date).format('dddd, MMMM D, YYYY')}</p> */}
                                                <p>{Helper.dateOnlyToLocalDatetime(items?.date).toDateString()}</p>

                                            </div>
                                            <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                <ClockSvg />
                                                <p>Start Time:</p>
                                                <p>{Helper.TimeConverter(items?.startTime)}</p>
                                            </div>
                                            <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                <DurationSvg />
                                                <p>Duration:</p>
                                                <p>{Helper.convertDecimalTime(items.durationHours)}</p>
                                            </div>
                                        </div>
                                        <div className={classes.grid1} >
                                            <div className={cx(classes.gridDetails, classes.hanken1)} style={{ alignItems: 'start', cursor: 'pointer' }} onClick={() => Maps(items.meetingPointInfo, 'Meeting and pickup')}>
                                                <FlagSvg />
                                                <p style={{ maxWidth: '300px' }}>Meeting and pickup: {items.meetingPointInfo}</p>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </div>
                                <hr hidden={window.innerWidth < 768} style={{ width: '100%' }} />
                            </div> : items.type === 'insurances' ? <div className={classes.details} key={key}>
                                <div className={classes.head}>
                                    <p className={classes.poppins} style={{ textAlign: 'left', maxWidth: '300px' }}>{items.insurance.plan}</p>
                                    <div className={classes.tittle}>
                                        <div style={{ cursor: 'pointer' }} onClick={() => setModal(items.id)}>
                                            <DeleteSvg />
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.priceBox}>
                                    <div className={classes.headModal}>
                                        <p className={classes.hanken1} style={{ fontSize: '12px', color: '#545D68' }}>Total Price</p>
                                        <p className={classes.poppins1}>${items.publishedPrice}</p>
                                    </div>
                                </div>
                                <div className={classes.insContent}>
                                    <button style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><CountryFlagSvg />{items.insurance.state}</button>
                                </div>
                                <p className={classes.poppins} style={{ textAlign: 'left', maxWidth: '300px', fontSize: '14px' }}>Details</p>
                                <div className={classes.persons}>
                                    {items.insuredPersons.map((pers: any, ind: number) => {
                                        return <div className={classes.persBox}>
                                            <p className={classes.hanken1} style={{ fontSize: '12px', color: '#758191' }}>Insured Person {ind + 1}</p>
                                            <p className={classes.hanken1}>{pers.firstname} {pers.lastname} {pers.dateOfBirth !== null && `- ${moment(pers.dateOfBirth).format("MMM DD YYYY")}`}</p>
                                        </div>
                                    })}
                                </div>
                                <div className={classes.persons}>
                                    <div className={classes.grid1}>
                                        <div className={cx(classes.gridDetails, classes.hanken1)}>
                                            <p>Confirmation Policy Number:</p>
                                            <p>{items?.confirmationPolicyNumber}</p>
                                        </div>
                                        <div className={cx(classes.gridDetails, classes.hanken1)}>
                                            <p>Trip Cost:</p>
                                            <p>{items?.tripCost}</p>
                                        </div>
                                        <div className={cx(classes.gridDetails, classes.hanken1)}>
                                            <p>Address:</p>
                                            <p>{items.address}</p>
                                        </div>
                                    </div>
                                    <div className={classes.grid1}>
                                        <div className={cx(classes.gridDetails, classes.hanken1)}>
                                            <p>Effective Date:</p>
                                            <p>{moment(items?.effectiveDate).format("dddd MMM DD YYYY")}</p>
                                        </div>
                                        <div className={cx(classes.gridDetails, classes.hanken1)}>
                                            <p>Departure Date:</p>
                                            <p>{moment(items?.departureDate).format("dddd MMM DD YYYY")}</p>
                                        </div>
                                        <div className={cx(classes.gridDetails, classes.hanken1)}>
                                            <p>Return Date:</p>
                                            <p>{moment(items?.returnDate).format("dddd MMM DD YYYY")}</p>
                                        </div>
                                        <div className={cx(classes.gridDetails, classes.hanken1)}>
                                            <p>Deposit Date:</p>
                                            <p>{moment(items?.depositDate).format("dddd MMM DD YYYY")}</p>
                                        </div>
                                    </div>
                                </div>
                            </div> : items.type === "accommodation" ? <div className={classes.details} key={key}>
                                <div className={classes.head}>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <p className={classes.poppins} style={{ textAlign: 'left', maxWidth: '300px', fontSize: '16px' }}>{items.roomDetails[0].roomDetail.name}</p>
                                        <p style={{ fontWeight: 700, fontSize: '14px', color: '#758191' }}>{items.accommodation.name}</p>
                                    </div>
                                    <div className={classes.tittle}>
                                        <div style={{ cursor: 'pointer' }} onClick={() => setModal(items.id)}>
                                            <DeleteSvg />
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.insContent}>
                                    <button style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{items.accommodation.numberOfStars}-Star</button>
                                    {items.accommodation.adultsOnly && <button style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Adults Only</button>}
                                </div>
                                <div className={classes.priceBox}>
                                    <div className={classes.headModal}>
                                        <p className={classes.hanken1} style={{ fontSize: '12px', color: '#545D68' }}>Full Price</p>
                                        <p className={classes.poppins2}>{items.payNow !== null && items.payNow > 0 && <span data-tooltip-id="my-tooltip" data-tooltip-content="You’ll have to pay the rest of a Full Price at a location!"> <DangerCircleSvg /></span>} ${items.publishedPrice}</p>
                                        <Tooltip id="my-tooltip"
                                            className={classes.tooltip}
                                        />
                                    </div>
                                    {items.payNow !== null && <hr />}
                                    {items.payNow !== null && <div className={classes.headModal}>
                                        <p className={classes.hanken1} style={{ fontSize: '12px', color: '#545D68' }}>Pay Now</p>
                                        <p className={classes.poppins1} style={{ fontSize: '16px' }}>${items.payNow}</p>
                                    </div>}
                                </div>
                                <p className={classes.hanken2} style={{ cursor: 'pointer' }} onClick={() => handleDetails(items.id)}>{showDetail === items.id ? 'Hide Details' : 'Show Details'} <span>{showDetail === items.id ? <DownSvg rotate={'rotate(180deg)'} /> : <DownSvg rotate={'rotate(0deg)'} />}</span></p>
                                {/* <p className={classes.poppins} style={{ textAlign: 'left', maxWidth: '300px', fontSize: '14px' }}>Details</p> */}
                                {showDetail === items.id && <div className={classes.persons}>
                                    <div className={classes.grid1}>
                                        <div className={cx(classes.gridDetails, classes.hanken1)}>
                                            <p><PersonSvg /></p>
                                            <p>Sleeps {items.roomDetails[0].roomDetail.maxOccupancy}</p>
                                        </div>
                                        <div className={cx(classes.gridDetails, classes.hanken1)}>
                                            <p><BedSvg /></p>
                                            <p>{items.roomDetails[0].roomDetail.beds}</p>
                                        </div>
                                        <div className={cx(classes.gridDetails, classes.hanken1)}>
                                            <p><FeetSvg /></p>
                                            <p>{items.roomDetails[0].roomDetail.size}</p>
                                        </div>
                                    </div>
                                    <div className={classes.grid1}>
                                        <div className={cx(classes.gridDetails, classes.hanken1)}>
                                            <p><MapSvg /></p>
                                            <p>{items.accommodation.locality}</p>
                                        </div>
                                        <div className={cx(classes.gridDetails, classes.hanken1)}>
                                            <p><PersonSvg /></p>
                                            <p>{items.persons.length} persons</p>
                                        </div>
                                    </div>
                                </div>}
                                <div className={classes.priceBox}>
                                    <div className={classes.headModal} style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                                        <p className={classes.hanken1} style={{ fontSize: '12px', color: '#758191' }}>Comment</p>
                                        <p className={classes.hanken1} style={{ color: '#273443' }}>{checkSpacing(items.comment) ? items.comment : 'no comment'}</p>
                                    </div>
                                </div>
                            </div> : items.type === 'train' ?
                                <div className={classes.details} key={key}>
                                    <div className={classes.head}>
                                        <p className={classes.poppins} style={{ textAlign: 'left', maxWidth: '400px', fontSize: '16px' }}>{items.train.trainCompany},{items.train.departureCity}-{items.train.arrivalCity}</p>
                                        <div className={classes.tittle}>
                                            <div style={{ cursor: 'pointer' }} onClick={() => setModal(items.id)}>
                                                <DeleteSvg />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={classes.priceBox}>
                                        <div className={classes.headModal}>
                                            <p className={classes.hanken1} style={{ fontSize: '12px', color: '#545D68' }}>Total Price</p>
                                            <p className={classes.poppins1}>${items.publishedPrice}</p>
                                        </div>
                                    </div>
                                    {showDetail === items.id ? <p onClick={() => handleDetails(items.id)} className={classes.hanken2} style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>Hide Details<span><DownSvg rotate={'rotate(180deg)'} /></span> </p> :
                                        <p onClick={() => handleDetails(items.id)} className={classes.hanken2} style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>Show Details<span><DownSvg /></span> </p>}
                                    {showDetail === items.id &&
                                        <div style={{ display: 'flex', gap: '12px', flexDirection: 'column', width: '100%' }}>
                                            <p className={classes.poppins} style={{ textAlign: 'left', maxWidth: '300px', fontSize: '14px' }}>Details</p>
                                            <div className={classes.buttonDisplay}>
                                                <button className={cx(classes.button1, classes.hanken2)}>Train number: {items.trainNumber}</button>
                                                <button className={cx(classes.button2, classes.hanken)} style={{ fontSize: '12px' }}>Cancellation Policy: {items.cancellationPolicy ? items.cancellationPolicy : 'none'}</button>
                                            </div>
                                            <div className={classes.persons}>
                                                <p className={classes.hanken1} style={{ display: 'flex', alignItems: 'center' }}><StarSvg />Operator: {items.train?.trainCompany}</p>
                                                <p className={classes.hanken1} style={{ display: 'flex', alignItems: 'center' }}><UpArrowSvg />Departure, time: {Time(items.departTime)}</p>
                                                <p className={classes.hanken1} style={{ display: 'flex', alignItems: 'center' }}><ClassSvg />Class: {items?.class}</p>
                                                <p className={classes.hanken1} style={{ display: 'flex', alignItems: 'center' }}><UpArrowSvg rotate={'rotate(180deg)'} />Arrival, time: {Time(items.arrivalTime)}</p>
                                                <p className={classes.hanken1} style={{ display: 'flex', alignItems: 'center' }}><SmallTrainSvg />Train type: {items?.trainType}</p>
                                            </div>

                                        </div>
                                    }
                                </div> : items.__typename === "ItineraryFlight" ?
                                    <div className={classes.details} key={key}>
                                        <div className={classes.head}>
                                            <p className={classes.poppins} style={{ textAlign: 'left', maxWidth: '400px', fontSize: '16px' }}>{items.flight.airlineName},{items.flight.departure.airportCode ? items.flight.departure.airportCode : items.flight.departureAirportCode}-{items.connectionFlights?.length > 0 ? items.connectionFlights[items.connectionFlights.length - 1]?.flight?.arrival?.airportCode ? items.connectionFlights[items.connectionFlights.length - 1].flight?.arrival?.airportCode : items.connectionFlights[items.connectionFlights.length - 1].flightarrivalAirportCode : items.flight.arrival.airportCode ? items.flight.arrival.airportCode : items.flight.arrivalAirportCode}</p>
                                            <div className={classes.tittle}>
                                                <div style={{ cursor: 'pointer' }} onClick={() => setModal(items.id)}>
                                                    <DeleteSvg />
                                                </div>
                                            </div>
                                        </div>
                                        <div className={classes.priceBox}>
                                            <div className={classes.headModal}>
                                                <p className={classes.hanken1} style={{ fontSize: '12px', color: '#545D68' }}>Total Price</p>
                                                <p className={classes.poppins1}>${handleFlightPrice(items)}</p>
                                            </div>
                                        </div>
                                        {showDetail === items.id ? <p onClick={() => handleDetails(items.id)} className={classes.hanken2} style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>Hide Details<span><DownSvg rotate={'rotate(180deg)'} /></span> </p> :
                                            <p onClick={() => handleDetails(items.id)} className={classes.hanken2} style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>Show Details<span><DownSvg /></span> </p>}
                                        {showDetail === items.id &&
                                            // <div style={{ display: 'flex', gap: '12px', flexDirection: 'column', width: '100%' }}>
                                            //     <p className={classes.poppins} style={{ textAlign: 'left', maxWidth: '300px', fontSize: '14px' }}>Details</p>
                                            //     <div className={classes.buttonDisplay}>
                                            //         <button className={cx(classes.button1, classes.hanken2)}>flight number: {items.flight.flgithNumber}</button>
                                            //         <button className={cx(classes.button2, classes.hanken)} style={{ fontSize: '12px' }}>Cancellation Policy: {items.cancellationPolicy ? items.cancellationPolicy : 'none'}</button>
                                            //     </div>
                                            //     <div className={classes.persons}>
                                            //         <p className={classes.hanken1} style={{ display: 'flex', alignItems: 'center' }}><StarSvg />Operator: {items?.flight?.airlineName}</p>
                                            //         <p className={classes.hanken1} style={{ display: 'flex', alignItems: 'center' }}><UpArrowSvg />Departure, time: {Time(items.departTime)}</p>
                                            //         <p className={classes.hanken1} style={{ display: 'flex', alignItems: 'center' }}><ClassSvg />Class: {items?.flightCabinType}</p>
                                            //         <p className={classes.hanken1} style={{ display: 'flex', alignItems: 'center' }}><UpArrowSvg rotate={'rotate(180deg)'} />Arrival, time: {Time(items.arrivalTime)}</p>
                                            //         {/* <p className={classes.hanken1} style={{ display: 'flex', alignItems: 'center' }}><SmallTrainSvg />Train type: {items?.trainType}</p> */}
                                            //     </div>

                                            // </div>
                                            <div>
                                                <div className={classes.subHeader}>
                                                    <div>
                                                        {
                                                            `${items.flight.departureAirport} (${items.flight?.departure?.airportCode}) - ${items?.connectionFlights.length > 0 ? items?.connectionFlights[items?.connectionFlights.length - 1]?.flight?.arrivalAirport : items.flight.arrivalAirport} (${items?.connectionFlights.length > 0 ? items?.connectionFlights[items?.connectionFlights.length - 1].flight?.arrival?.airportCode : items.flight.arrival?.airportCode})`
                                                        }
                                                    </div>
                                                    <div className={classes.DepartureTime} style={{ color: '#FF3566', margin: '0px 0px 0px 48px' }}>{items?.connectionFlights.length > 0 ? `${items?.connectionFlights.length} stop` : 'Direct Flight'}</div>
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <div className={classes.FlightFeature}>
                                                        <div className={classes.DepartureTime}>{moment(ActualTime(items?.departDate)).format('dddd, MMMM D YYYY')}
                                                        </div>
                                                    </div>
                                                    <div className={classes.FlightFeature}>
                                                        <div className={classes.ArrivalTime}>
                                                            {Time(items?.departTime)} -&nbsp;
                                                            {items?.connectionFlights.length > 0 ? Time(items?.connectionFlights[items?.connectionFlights.length - 1].arrivalTime) : Time(items?.arrivalTime)}
                                                        </div>
                                                        <div className={classes.DepartureTime}>{handleDuration(items, 'n')}</div>
                                                    </div>
                                                    <div className={classes.FlightFeature} style={{ paddingTop: '20px' }}>
                                                        <div className={classes.DepartureTime} style={{ color: '#273443' }}><span>
                                                            <FlightSvg width='15' height='15' /></span>
                                                            {
                                                                `${items.flight.departureAirport} (${items.flight?.departure?.airportCode}) - ${items.flight.arrivalAirport} (${items?.flight?.arrival?.airportCode})`
                                                            }
                                                        </div>
                                                        <div className={classes.DepartureTime}>
                                                            {items?.flightCabinType}
                                                        </div>
                                                    </div>
                                                    <div className={classes.FlightFeature}>
                                                        <div className={classes.ArrivalTime}>
                                                            {Time(items?.departTime)} -&nbsp;
                                                            {Time(items?.arrivalTime)}
                                                        </div>
                                                        <div className={classes.DepartureTime}>{handleDuration(items, 'direct')}</div>
                                                    </div>
                                                    <div className={classes.FlightFeature}>
                                                        <div className={classes.ArrivalTime}>
                                                            {items?.flight?.flgithNumber}
                                                        </div>
                                                        <div className={classes.DepartureTime}>{items?.flight?.airlineName}</div>
                                                    </div>
                                                    {items?.connectionFlights.length > 0 ?
                                                        items.connectionFlights.sort((a: any, b: any) => {
                                                            if (a.connectionFlightOrder === null || b.connectionFlightOrder === null)
                                                                return -1
                                                            else
                                                                return a.connectionFlightOrder - b.connectionFlightOrder
                                                        })
                                                            .map((n: any, index: number) => {
                                                                return <div>
                                                                    {index === 0 ?
                                                                        <div className={classes.DepartureTime} style={{ color: '#FF3566' }}>
                                                                            {handleConnectionDuration(items, n, 'connect')}
                                                                        </div> : <div className={classes.DepartureTime} style={{ color: '#FF3566' }}>
                                                                            {handleConnectionDuration(items.connectionFlights[index - 1], items.connectionFlights[index], 'connect')}
                                                                        </div>
                                                                    }
                                                                    <div className={classes.FlightFeature} style={{ paddingTop: '20px' }}>
                                                                        <div className={classes.DepartureTime} style={{ color: '#273443' }}><span>
                                                                            <FlightSvg width="15" height="15" /></span>
                                                                            {
                                                                                `${n.flight.departureAirport} (${n.flight?.departure?.airportCode}) - ${n.flight.arrivalAirport} (${n.flight?.arrival?.airportCode})`
                                                                            }
                                                                        </div>
                                                                        <div className={classes.DepartureTime}>
                                                                            {n?.flightCabinType}
                                                                        </div>
                                                                    </div>
                                                                    <div className={classes.FlightFeature}>
                                                                        <div className={classes.ArrivalTime}>
                                                                            {Time(n?.departTime)} -&nbsp;
                                                                            {Time(n?.arrivalTime)}
                                                                        </div>
                                                                        <div className={classes.DepartureTime}>{handleDuration(n, 'direct')}</div>
                                                                    </div>
                                                                    <div className={classes.FlightFeature}>
                                                                        <div className={classes.ArrivalTime}>
                                                                            {n?.flight?.flgithNumber}
                                                                        </div>
                                                                        <div className={classes.DepartureTime}>{n?.flight?.airlineName}</div>
                                                                    </div>
                                                                </div>
                                                            })
                                                        : null}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    : null

                        })}
                    </div>

                    <hr hidden={window.innerWidth > 768} style={{ width: '100%', background: 'white' }} />
                    <div className={classes.box1}>
                        {window.innerWidth > 768 && <div className={classes.item} style={{ width: '100%' }}>
                            <p className={classes.poppins}>Price Details</p>
                            {/* {window.innerWidth < 768 && <p onClick={() => setPriceDetail(!priceDetail)}>{priceDetail ? <DownSvg rotate={'rotate(180deg)'} /> : <DownSvg rotate={'rotate(0deg)'} />}</p>} */}
                        </div>}
                        {window.innerWidth > 768 && <div className={classes.checkout}>
                            <div className={classes.item}>
                                <p className={classes.hanken1}>Number of Travallers</p>
                                <p className={classes.hanken1}>{ItineraryData.queryItinerary[0].persons.length}</p>
                            </div>
                            <div className={classes.item}>
                                <p className={classes.hanken1}>Total</p>
                                <p className={classes.hanken1}>{handlePrice('total')}</p>
                            </div>
                            <div className={classes.item}>
                                <p className={classes.hanken1}>Balance</p>
                                <p className={classes.hanken1}>{handlePrice('payLater')}</p>
                            </div>
                            <hr style={{ width: '100%' }} />
                            <div hidden={window.innerWidth < 768} className={classes.item}>
                                <p className={classes.hanken1} style={{ fontSize: '20px' }}>Pay now</p>
                                <p className={classes.poppins}>{handlePrice('payNow')}</p>
                            </div>
                            <hr hidden={window.innerWidth < 768} style={{ width: '100%' }} />

                        </div>}
                        {window.innerWidth < 768 &&
                            <>
                                <div className={classes.item} style={{ width: '100%' }}>
                                    <p className={classes.poppins}>Price Details</p>
                                    {<p onClick={() => setPriceDetail(!priceDetail)}>{priceDetail ? <DownSvg rotate={'rotate(180deg)'} /> : <DownSvg rotate={'rotate(0deg)'} />}</p>}
                                </div>
                                {priceDetail && <div className={classes.checkout}>
                                    <div className={classes.item}>
                                        <p className={classes.hanken1}>Number of Travallers</p>
                                        <p className={classes.hanken1}>{ItineraryData.queryItinerary[0].persons.length}</p>
                                    </div>
                                    <div className={classes.item}>
                                        <p className={classes.hanken1}>Total</p>
                                        <p className={classes.hanken1}>{handlePrice('total')}</p>
                                    </div>
                                    <div className={classes.item}>
                                        <p className={classes.hanken1}>Balance</p>
                                        <p className={classes.hanken1}>{handlePrice('payLater')}</p>
                                    </div>
                                    <hr style={{ width: '100%' }} />
                                </div>}
                            </>}

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}><StyledCheckbox onChange={handleChange} checked={checked} /> <p style={{ textAlign: 'left' }} className={classes.hanken1}><a href='s' style={{ color: '#0279CF', textDecoration: 'underline' }}>Terms & Conditions</a> Acceptance</p></div>
                        <div style={{ display: "none" }} id="paymentDiv"></div>
                        <button onClick={() => handleCheckout()} hidden={window.innerWidth < 768} className={classes.checkoutbutton}>Checkout
                        </button>
                        {
                            window.innerWidth < 768 &&
                            <div className={classes.tittle}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <p className={classes.hanken1} style={{ fontSize: '20px' }}>Pay now</p>
                                    <p className={classes.poppins}>{handlePrice('total')}</p>
                                </div>
                                <button className={classes.checkoutbutton} style={{ width: 'fit-Content' }} onClick={() => handleCheckout()}>Checkout</button>

                            </div>
                        }

                    </div>
                </div> : cart.length === 0 && !loading ? <div className={classes.SuccessPage}>

                    <div className={classes.ModalContent}>
                        <div style={{ width: 'fit-Content' }}><img src={cartLogo} width={200} height={200} alt='cart' /></div>
                        <div className={classes.ScrollContainer}>
                            <p className={classes.cartHead}>Your Cart is empty</p>

                            <p>You have no items in your Itinerary cart. Let's go add something!</p>
                            {/* <button onClick={() => setView('itinerary')} className={classes.checkoutbutton}>Go to Itineray</button> */}
                        </div>

                    </div>
                </div> : <Loader content='Loading...' />}

            {modal !== '' && <DeleteModal setModal={setModal} modal={modal} handleDelete={handleDelete} />}
            {loader ? <SuccessPage successEmail={''} /> : null}
        </div>
    )
}

export default ShoppingCart